import React from 'react'
import { useSelector } from 'react-redux'

export default () => {
  const { appSettings } = useSelector((state) => state.app)
  const { showLoginImageOnMobile, showHeaderOnLoginPage } = useSelector(
    (state) => state.app.appSettings,
  )

  const {
    theme: {
      images: {
        loginImage: { src, alt },
      },
    },
  } = appSettings

  return src ? (
    <div
      className={`login-image ${showLoginImageOnMobile ? 'show' : 'hide-login-img'} 
      ${showHeaderOnLoginPage ? '' : 'full-height'}`}
      style={{ backgroundImage: `url(${src})` }}
      role="img"
      aria-label={__.trans(alt)}
    />
  ) : null
}
